import { render, staticRenderFns } from "./CashierDashboardSidebar.vue?vue&type=template&id=1020358e&scoped=true&"
import script from "./CashierDashboardSidebar.vue?vue&type=script&lang=js&"
export * from "./CashierDashboardSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CashierDashboardSidebar.vue?vue&type=style&index=0&id=1020358e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1020358e",
  null
  
)

export default component.exports